import { render, staticRenderFns } from "./add-point.vue?vue&type=template&id=ae2ea196&"
import script from "./add-point.vue?vue&type=script&lang=js&"
export * from "./add-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports